module.exports = __webpack_public_path__ + "static/media/people1-min.e6b59e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/people1-min.png
// module id = 450
// module chunks = 0